import { Progress } from '@tempo-io/sui-progress';
import { Tooltip, TooltipContent, TooltipTrigger } from '@tempo-io/sui-tooltip';
import { isFiniteNumber } from '@/common/utils/number';

export const ProgressCell = ({
  value,
  min,
  max,
  label,
}: {
  value?: number;
  min: number;
  max: number;
  label?: string;
}) =>
  isFiniteNumber(value) && (
    <Tooltip>
      <TooltipTrigger asChild>
        <Progress
          value={value}
          max={max}
          indicatorClassName="bg-bg-neutral-bold"
          aria-label={label}
          aria-valuenow={value}
          aria-valuemin={min}
          aria-valuemax={max}
        />
      </TooltipTrigger>
      <TooltipContent side="bottom" align="center">
        {Math.round(value)}
      </TooltipContent>
    </Tooltip>
  );
